module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_qq.13f7d.png";